import { usePrivy } from "@privy-io/react-auth";
import { Spinner } from "."
import logoGoldsand from "../../assets/logo-goldsand-v2.png";

interface NotLoggedInProps {
  resolving: boolean;
  tokenInvalid: boolean;
}

const LinkExpired = () => (
  <>
    <h1 className="-mt-6 text-lg font-bold">Session expired</h1>
    <p className="text-base text-muted-fg leading-relaxed">
      Your link has expired or is invalid. Please go back to the app and try again.
    </p>
  </>
);

const SignIn = () => {
  const { login} = usePrivy();
  return (
    <>
      <h1 className="-mt-6 text-lg font-bold">Goldsand Support</h1>
      <p className="text-base text-muted-fg leading-relaxed">
        Please sign in so we can provide better and more personalized support.
      </p>
      <button
        type="button"
        onClick={() => login({ loginMethods: ["email"] })}
        className="btn-primary mt-xs h-[48px] px-[32px] rounded-full bg-foreground text-primary-fg text-base font-semibold cursor-pointer shadow-[0_2px_8px_rgba(0,0,0,0.12)]"
      >
        Sign in with email
      </button>
    </>
  )
};

const PageContent = ({ resolving, tokenInvalid }: NotLoggedInProps) => {
  if (resolving) return <Spinner size={24} />;
  if (tokenInvalid) return <LinkExpired />;
  return <SignIn />;
}

const NotLoggedIn = ({ resolving, tokenInvalid }: NotLoggedInProps) => {
  return (
    <div className="min-h-dvh flex items-center justify-center bg-background text-foreground px-lg">
      <div className="max-w-[420px] w-full flex flex-col items-center text-center gap-md">
        <img src={logoGoldsand} alt="Goldsand logo" className="h-[150px] rounded-[16px] object-cover" />
          <PageContent resolving={resolving} tokenInvalid={tokenInvalid} />
      </div>
    </div>
  );
};

export default NotLoggedIn;
